import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-lang-switcher-dashboard',
  templateUrl: './lang-switcher-dashboard.component.html',
  styleUrls: ['./lang-switcher-dashboard.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class LangSwitcherDashboardComponent {
  @Input() isEn: boolean = true;
  @Output() toggleLanguage: EventEmitter<boolean> = new EventEmitter();

  fireToggleLanguage() {
    this.toggleLanguage.emit(true);
  }

}
